<template>
    <div>
      <area-form
        :is-area-form-sidebar-active.sync="isAreaFormSidebarActive"
            :area-data="areaData"
            @refetch-data="refetchData" 
        />
        <widgets-form
        :is-widget-form-sidebar-active.sync="isWidgetFormSidebarActive"
            :widget-data="widgetData"
            @refetch-data="refetchData" 
        />
        <b-card no-body
        >
          <div class="m-2">
            <div class="d-flex align-items-center justify-content-end">
                <b-button
                variant="primary"
                @click="addArea"
              >
                <span class="text-nowrap">Add Area</span>
              </b-button>
            </div>
          </div>
        </b-card>

        <b-card v-for="(ng,key) in areas" :key="'area'+key" action-collapse  >
          <b-card-header class="pb-50">
            
            <b-row class="w-100">
              <b-col  cols="10">
                <h3>
                  {{ ng.title }}
                </h3>
              </b-col>
              <b-col cols="2">
                <div class="d-flex align-items-center justify-content-end">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="btn-icon"
                      @click="updateArea(ng)"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="danger"
                      class="btn-icon ml-1"
                      @click="deleteAreaconfirm(ng.id)"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                </div>
              </b-col>
            </b-row>
            
          </b-card-header>
          <b-card-body>
            <div class="d-flex align-items-center mb-2">
                <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="addWidget(ng.id)"
                class="btn-icon"
              >
              <feather-icon icon="PlusCircleIcon" />
              </b-button>
            </div>
            
            <draggable
              :list="ng.widgets"
              tag="ul"
              @change="undateOrdering(key)"
              class="list-group list-group-flush cursor-move"
            >
              <b-list-group-item
                v-for="(itm, index) in ng.widgets"
                :key="index"
                tag="li"
              >
              
                  <b-row >
                    <b-col cols="10">
                      <div class="p-1">
                        {{ itm.title }}
                      </div>
                    </b-col>
                    <b-col cols="2">
                      <div class="d-flex  justify-content-end">
                        <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="btn-icon"
                      @click="updateWidget(itm)"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="danger"
                      class="btn-icon ml-1"
                      @click="deleteconfirm(itm.id)"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                      </div>
                    </b-col>
                  </b-row>
                  
                 

                
              
              </b-list-group-item>
            </draggable>
            <!--<vue-drag-tree :data='data' :allowDrag='allowDrag' :allowDrop='allowDrop' :defaultText='"New Node"' @current-node-clicked='curNodeClicked' @drag="dragHandler" @drag-enter="dragEnterHandler" @drag-leave="dragLeaveHandler" @drag-over="dragOverHandler" @drag-end="dragEndHandler" @drop="dropHandler" v-slot="slotProps">
               
                <span :class="[slotProps.isClicked ? 'i-am-clicked' : 'i-am-not-clicked']"></span>
                <span class='i-am-node-name'>{{slotProps.nodeName}}</span>
            </vue-drag-tree>-->
          </b-card-body>
        </b-card>
       
    </div>
</template>
<script>


import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
  BListGroupItem,BCardHeader,BCardBody
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
//api
import axios from '@axios'
import store from '@/store'
import { ref,onUnmounted } from '@vue/composition-api'
import useWidgetsList from './useWidgetsList'
import widgetsStoreModule from '../widgetsStoreModule'
//import GroupForm from '../navigation-form/GroupForm.vue'
//import NavigationForm from '../navigation-form/NavigationForm.vue'

import AreaForm from '../widgets-form/AreasForm.vue'
import WidgetsForm from '../widgets-form/WidgetsForm.vue'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
export default{
    components:{
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
        BCardActions,
        Prism,
        draggable,
        BListGroupItem,
        AreaForm,
        BCardHeader,
        BCardBody,
        AreaForm,
        WidgetsForm
        //NavigationForm
        
        

    },
    directives:{
        'b-modal': VBModal,
        Ripple

    },
    setup(){

      const WIDGET_STORE_MODULE_NAME = 'app-widget';
        if (!store.hasModule(WIDGET_STORE_MODULE_NAME)) store.registerModule(WIDGET_STORE_MODULE_NAME, widgetsStoreModule)
        onUnmounted(() => {
            if (store.hasModule(WIDGET_STORE_MODULE_NAME)) store.unregisterModule(WIDGET_STORE_MODULE_NAME)
        });
        const {
          areas,
          undateOrdering,
          updateArea,
          refetchData,
          isAreaFormSidebarActive,
          isWidgetFormSidebarActive,
          areaData,
          addArea,
          addWidget,
          updateWidget,
          widgetData,
          deleteData,
          deleteAreaData

        } = useWidgetsList();
        return {
            areas,
          undateOrdering,
          updateArea,
          refetchData,
          isAreaFormSidebarActive,
          isWidgetFormSidebarActive,
          areaData,
          addArea,
          addWidget,
          updateWidget,
          widgetData,
          deleteData,
          deleteAreaData

        }
    },
    data(){
        return {
            data: [
                {
                name: 'Node 0-0',
                id: 0,
                children: [
                    {
                    name: 'Node 1-1',
                    id: 3,
                    children: [
                        {
                        name: 'Node 2-1',
                        id: 4,
                        children: []
                        },
                        {
                        name: 'Node 2-2',
                        id: 10,
                        children: []
                        }
                    ]
                    },
                    {
                    name: 'Node 1-2',
                    id: 13,
                    children: []
                    }
                ]
                },
                {
                name: 'Node 0-1',
                id: 14,
                children: []
                }
            ],
            navigations_groups:[
                {
                    id:1,
                    title:'Header',
                    slug:'header'
                },
                {
                    id:2,
                    title:'Footer',
                    slug:'footer'
                }
            ],
            navigations: [
                { text: "node 1" },
                { text: "node 2" },
                { text: "node 3 undraggable" },
                { text: "node 4" },
                { text: "node 4 undroppable", droppable: false },
            ]
        }
    },
    methods:{
      deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Widget ID.'+id, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                    })
                    .then(value => {
                    if(value === true){
                    this.deleteData(id)
                    }
                
                    //this.deleteData(id)
                    })
    
    },
    deleteAreaconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Area ID.'+id, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                    })
                    .then(value => {
                    if(value === true){
                    this.deleteAreaData(id)
                    }
                
                    //this.deleteData(id)
                    })
    
    },
        allowDrag(model, component) {
      if (model.name === 'Node 0-1') {
        // can't be dragged
        //return false;
      }
      // can be dragged
      return true;
    },
    allowDrop(model, component) {
      if (model.name === 'Node 2-2') {
        // can't be placed
        //return false;
      }
      // can be placed
      return true;
    },
    curNodeClicked(model, component) {
      // console.log('curNodeClicked', model, component);
    },
    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    }
    }
}

</script>